import Phaser from 'phaser';
import { PreloadScene } from './scenes/PreloadScene';
import { MainMenuScene } from './scenes/MainMenuScene';
import { MetaShopScene } from './scenes/MetaShopScene';
import { GameScene } from './scenes/GameScene';
import { GameOverScene } from './scenes/GameOverScene';
import { phaserConfig } from './config/GameConfig';

// Initialize the game
const config: Phaser.Types.Core.GameConfig = {
  ...phaserConfig,
  scene: [PreloadScene, MainMenuScene, MetaShopScene, GameScene, GameOverScene]
};

window.addEventListener('load', () => {
  new Phaser.Game(config);
});
